import { all } from 'redux-saga/effects';

// MAIN
import accounts from './main/accounts/sagas';
import associations from './main/associations/sagas';
import dealers from './main/dealers/sagas';
import grouping from './main/grouping/sagas';

export default function* rootSaga() {
  return yield all([
    // MAIN
    accounts,
    associations,
    dealers,
    grouping,
  ]);
}
